<template>
  <div id="app" :class="this.$route.path == '/laporan' ? 'fullwidth' : ''">
    <router-view />

    <div
      class="bottom-bar"
      v-if="this.$route.path != '/login' && this.$route.path != '/laporan'"
    >
      <div>
        <router-link to="/" :class="$route.path == '/' ? 'active' : ''">
          <home />
        </router-link>
      </div>

      <div>
        <router-link
          to="/notulen"
          :class="$route.path.indexOf('notulen') > -1 ? 'active' : ''"
        >
          <Notulen />
        </router-link>
      </div>

      <div>
        <router-link
          to="/task"
          :class="
            ['/task', '/add', '/detail'].indexOf($route.path) > -1 ||
            $route.path.indexOf('/detail') > -1
              ? 'active'
              : ''
          "
        >
          <history />
        </router-link>
      </div>

      <div>
        <router-link
          to="/notifikasi"
          :class="{ active: $route.path == '/notifikasi' }"
        >
          <Notifikasi />
        </router-link>
      </div>

      <div>
        <router-link
          to="/profil"
          :class="$route.path == '/profil' ? 'active' : ''"
        >
          <user />
        </router-link>
      </div>
    </div>

    <!-- <div class="toast" v-if="$store.state.settings.toast">
      <p>
        {{ $store.state.settings.toast }}
      </p>
    </div> -->
  </div>
</template>

<script>
import Home from "@/components/icons/Home.vue";
import Add from "@/components/icons/Add.vue";
import History from "@/components/icons/History.vue";
import User from "@/components/icons/User.vue";
import Notulen from "@/components/icons/Notulen.vue";
import Notifikasi from "@/components/icons/Notifikasi.vue";

import * as api from "./api/Api";

export default {
  name: "App",
  components: {
    Home,
    Add,
    History,
    User,
    Notulen,
    Notifikasi,
  },
  methods: {
    closeSidebar(e) {
      if (e.target.classList[0] == "sidebar-overlay") {
        this.$store.commit("settings/setSidebarOpen", false);
      }
    },
    updateToken(token) {
      api.post("/v1/kendali_kerja/pekerjaanController/updateToken", {
        id_user: this.$user.id,
        token: token,
      });
    },
  },
  created() {
    const self = this;
    document.addEventListener(
      "deviceready",
      () => {
        if (this.$store.state.settings.user.id) {
          cordova.plugins.firebase.messaging
            .requestPermission({ forceShow: true })
            .then(function () {
              // if allowed then update token

              cordova.plugins.firebase.messaging
                .getToken()
                .then(function (token) {
                  self.updateToken(token);
                });
            });

          cordova.plugins.firebase.messaging.onTokenRefresh(function (token) {
            // Kirim token baru ke server Anda
            self.updateToken(token);
          });

          cordova.plugins.firebase.messaging.onMessage((payload) => {
            setTimeout(() => {
              self.$store.commit("settings/setNotifikasi", true);
            }, 750);
          });

          cordova.plugins.firebase.messaging.onBackgroundMessage((payload) => {
            setTimeout(() => {
              self.$store.commit("settings/setNotifikasi", true);
            }, 750);
          });
        }
      },
      false
    );
  },
  mounted() {
    if (this.$route.path != "/login") {
      if (!this.$store.state.settings.user.id) {
        this.$router.push("/login");
      }
    }
  },
};
</script>

<style lang="scss">
// @import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Wix+Madefor+Display:wght@400;600&display=swap");

body {
  margin: 0;
}

:root {
  --primary-disabled: #7ba5ff;
  --primary: #007aff;
  --primary-darker: #235bd5;
}

* {
  // font-family: "Montserrat", sans-serif;
  font-family: "Wix Madefor Display", sans-serif;
}

@media screen and (min-width: 480px) {
  #app {
    max-width: 480px;
    margin: 0 auto;
    min-height: 100vh;
    box-shadow: 0px 0px 10px #ccc;
    position: relative;

    &.fullwidth {
      max-width: 100%;
    }
  }
}

.form-group {
  margin-bottom: 15px;
  label {
    display: block;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 6px;
  }
}

input,
select,
textarea {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 10px;
  width: calc(100% - 22px);
  outline: none;
  font-size: 14px;

  &:focus {
    border: 1px solid var(--primary);
  }
}

select {
  width: 100%;
}

.btn {
  background: var(--primary);
  color: #fff;
  padding: 13px;
  outline: none;
  border: 0;
  border-radius: 6px;
  width: 100%;
  font-weight: bold;
  text-transform: uppercase;

  &:active {
    background: #03288b;
  }
  &:disabled {
    background: var(--primary-disabled);
  }
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  left: calc(50% - 240px);
  width: 480px;
  background-color: #fff;
  border-radius: 15px 15px 0 0;
  display: grid;
  box-shadow: 0px -2px 3px #ddd;
  grid-template-columns: repeat(5, 1fr);

  @media screen and (max-width: 768px) {
    left: 0;
    width: 100%;
  }

  div {
    display: flex;
    justify-content: center;
  }

  a {
    padding: 10px;
    margin: 10px;
    border-radius: 50px;
    color: #333;

    &.active {
      background: #d7ebf5;
      color: #1d9de3;
    }
    .icon {
      width: 22px;
    }

    &:active {
      background-color: #eee;
    }
  }
}

.toast {
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
  bottom: 50%;
  left: 15px;
  border-radius: 6px;

  p {
    color: #fff;
    margin: 0;
    padding: 20px 15px;
    text-align: center;
  }
}
@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.animate-flicker {
  -webkit-animation: flickerAnimation 1s infinite;
  -moz-animation: flickerAnimation 1s infinite;
  -o-animation: flickerAnimation 1s infinite;
  animation: flickerAnimation 1s infinite;
}

.task {
  padding: 0 15px;
  .task-filter {
    display: flex;
    justify-content: space-between;

    > div {
      &:last-child {
        padding-right: 15px;
        select {
          margin: 1rem;
          border-radius: 10px;
          padding-left: 5px;
        }
      }
    }
  }
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;

    li {
      background: #fff;
      padding: 15px;
      border-radius: 6px;
      margin-bottom: 15px;
      display: flex;
      gap: 10px;
      justify-content: space-between;
      // box-shadow: 0px 3px 3px #ccc;
      border: 1px solid #ccc;
      &.warning {
        // border: 2px solid #f5b400;
      }

      &.complete {
        // border: 2px solid #6ee569;
      }

      &.danger {
        // border: 2px solid #d64948;
      }

      &:active {
        background: #f9f9fc;
      }
      .icon {
        width: 20px;
        height: 20px;
      }
      p {
        margin: 0;
        font-weight: bold;
        font-size: 16px;
        color: #333;
      }
      small {
        font-size: 12px;
        font-weight: 500;
        color: #777;
        &:first-child {
          font-size: 13px;
        }
        &.red {
          color: #c22525;
        }
      }
      > div {
        &:last-child {
          display: flex;
          align-items: center;
        }
      }

      span.badge {
        font-size: 13px;
        color: #fff;
        padding: 4px 7px;
        border-radius: 4px;
        white-space: nowrap;

        &.in_progress {
          background: #0588ff;
        }

        &.todo {
          background: #f5b400;
        }

        &.complete {
          background: #7bd078;
        }

        &.overdue {
          border: 1px solid #d64948;
          background: #fff;
          color: #d64948;
        }
      }
    }
  }
}

.skeleton {
  background-color: #eee;
  // The shine that's going to move across the skeleton:
  background-image: linear-gradient(
    90deg,
    rgba(#fff, 0),
    rgba(#fff, 0.5),
    rgba(#fff, 0)
  );
  background-size: 40px 100%; // width of the shine
  background-repeat: no-repeat; // No need to repeat the shine effect
  background-position: left -40px top 0; // Place shine on the left side, with offset on the left based on the width of the shine - see background-size
  animation: shine 1s ease infinite; // increase animation time to see effect in 'slow-mo'
}

@keyframes shine {
  to {
    // Move shine from left to right, with offset on the right based on the width of the shine - see background-size
    background-position: right -40px top 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue